{
  "action": {
    "close_filter": "Filter sluiten",
    "details": "Details",
    "filter": "Filteren"
  },
  "event": {
    "AirGapViolationDetected": "Internetverbinding gedetecteerd. Abacus gaat op slot.",
    "AirGapViolationResolved": "Geen internetverbinding meer gedetecteerd.",
    "ApiError": "API fout",
    "ApiWarning": "API waarschuwing",
    "ApplicationStarted": "Abacus is gestart",
    "ApportionmentProcessed": "Zetelverdeling verwerkt",
    "ApportionmentStateUpdated": "Zetelverdeling status bijgewerkt",
    "CommitteeSessionCreated": "Zitting aangemaakt",
    "CommitteeSessionDeleted": "Zitting verwijderd",
    "CommitteeSessionUpdated": "Zitting bijgewerkt",
    "DatabaseBackupCreated": "Back-up van de database gemaakt",
    "DataEntryDeleted": "Invoer verwijderd",
    "DataEntryDiscarded": "Invoer afgebroken",
    "DataEntryDiscardedBoth": "Beide invoeren verwijderd",
    "DataEntryDiscardedFirst": "Eerste invoer verwijderd",
    "DataEntryFinalised": "Invoer afgerond",
    "DataEntryImported": "Invoer geïmporteerd",
    "DataEntryKeptFirst": "Eerste invoer bewaard",
    "DataEntryKeptFirstReturnedSecond": "Eerste invoer bewaard, tweede teruggegeven",
    "DataEntryKeptSecond": "Tweede invoer bewaard",
    "DataEntryKeptSecondReturnedFirst": "Tweede invoer bewaard, eerste teruggegeven",
    "DataEntryReset": "Invoer verwijderd",
    "DataEntryResumed": "Invoer hervat",
    "DataEntryReturnedFirst": "Eerste invoer teruggegeven",
    "DataEntrySaved": "Invoer opgeslagen",
    "DataEntryStarted": "Invoer gestart",
    "ElectionCreated": "Verkiezing aangemaakt",
    "ElectionUpdated": "Verkiezing bijgewerkt",
    "FileCreated": "Bestand aangemaakt",
    "FileDeleted": "Bestand verwijderd",
    "InvestigationConcluded": "Onderzoek afgerond",
    "InvestigationCreated": "Onderzoek gestart",
    "InvestigationDeleted": "Onderzoek verwijderd",
    "InvestigationUpdated": "Onderzoek bijgewerkt",
    "PollingStationCreated": "Stembureau aangemaakt",
    "PollingStationDeleted": "Stembureau verwijderd",
    "PollingStationUpdated": "Stembureau bijgewerkt",
    "PollingStationsImported": "Stembureaus geïmporteerd",
    "PollingStationsExported": "Stembureaus geëxporteerd",
    "PublicKeyUploadReminderDismissed": "Publieke sleutel uploadherinnering afgevinkt",
    "SigningKeypairCreated": "Sleutelpaar voor digitale handtekeningen aangemaakt",
    "SubCommitteeCertificateAdded": "Publieke sleutel GSB toegevoegd",
    "SubCommitteeCertificateDeleted": "Publieke sleutel GSB verwijderd",
    "UnknownEvent": "Onbekende gebeurtenis",
    "UserAccountUpdated": "Eigen account bijgewerkt",
    "UserCreated": "Gebruikersaccount aangemaakt",
    "UserDeleted": "Gebruikersaccount verwijderd",
    "UserLoggedIn": "Gebruiker ingelogd",
    "UserLoggedOut": "Gebruiker uitgelogd",
    "UserLoginFailed": "Mislukte inlogpoging",
    "UserSessionExtended": "Gebruikerssessie verlengd",
    "UserUpdated": "Gebruikersaccount bijgewerkt"
  },
  "field": {
    "commit": "Commit",
    "committee_session_id": "Zitting-ID",
    "corrected_results": "Gecorrigeerde uitkomst",
    "created_at": "Aangemaakt op",
    "data_entry_id": "Invoer-ID",
    "data_entry_progress": "Voortgang",
    "data_entry_status": "Status",
    "election_category": "Verkiezingscategorie",
    "election_committee_category": "Verkiezingsrol",
    "election_counting_method": "Stemopneming",
    "election_domain_id": "Verkiezingsregio-ID",
    "election_election_date": "Verkiezingsdatum",
    "election_election_id": "Verkiezings-ID",
    "election_id": "Verkiezings-ID",
    "election_location": "Verkiezingslocatie",
    "election_name": "Verkiezingsnaam",
    "election_nomination_date": "Nominatiedatum",
    "election_number_of_seats": "Aantal zetels",
    "election_number_of_voters": "Aantal kiezers",
    "election_status": "Verkiezingsstatus",
    "error_reference": "Referentie fout",
    "event_type": "Gebeurtenis",
    "file_created_at": "Aangemaakt op",
    "file_hash": "Digitale vingerafdruk",
    "file_id": "Bestands-ID",
    "file_mime_type": "Bestandstype",
    "file_name": "Bestandsnaam",
    "file_size_bytes": "Bestandsgrootte (bytes)",
    "filename": "Bestandsnaam",
    "findings": "Bevindingen",
    "finished_at": "Afgerond op",
    "first_entry_origin": "Eerste invoer (import of Gebruikers-ID)",
    "fullname": "Volledige naam",
    "import_election_id": "Verkiezings-ID",
    "import_file_name": "Bestandsnaam",
    "import_number_of_polling_stations": "Aantal geïmporteerde stembureaus",
    "ip": "IP-adres",
    "level": "Type",
    "logged_in_users_count": "Aantal ingelogde gebruikers",
    "number_of_polling_stations": "Aantal stembureaus",
    "path": "Pad",
    "polling_station_address": "Adres stembureau",
    "polling_station_committee_session_id": "Zitting-ID",
    "polling_station_election_id": "Verkiezings-ID",
    "polling_station_id": "Stembureau-ID",
    "polling_station_locality": "Plaats stembureau",
    "polling_station_name": "Naam stembureau",
    "polling_station_number": "Nummer stembureau",
    "polling_station_number_of_voters": "Aantal kiesgerechtigden",
    "polling_station_postal_code": "Postcode stembureau",
    "polling_station_prev_data_entry_id": "Invoer-ID vorige zitting",
    "polling_station_type": "Type stembureau",
    "reason": "Aanleiding",
    "role": "Rol",
    "second_entry_user_id": "Gebruikers-ID tweede invoer",
    "session_duration": "Sessieduur (seconden)",
    "session_election_id": "Verkiezings-ID",
    "session_id": "Zitting-ID",
    "session_location": "Plaats van de zitting",
    "session_number": "Nummer zitting",
    "session_number_of_voters": "Aantal kiesgerechtigden",
    "session_overview_pdf": "Bestandsgrootte PDF",
    "session_results_eml": "Bestandsgrootte EML",
    "session_results_pdf": "Bestandsgrootte PDF",
    "session_start_date_time": "Datum en tijdstip aanvang van de zitting",
    "session_status": "Status zitting",
    "state": "Status",
    "user_agent": "User agent",
    "user_id": "Gebruikers-ID",
    "username": "Gebruikersnaam",
    "version": "Versie"
  },
  "filter": {
    "event": "Gebeurtenis",
    "level": "Type",
    "show_events_since": "Sinds",
    "user": "Gebruiker"
  },
  "header": {
    "details": "Details",
    "event": "Gebeurtenis",
    "level": "Type",
    "message": "Toelichting",
    "since": "Sinds",
    "time": "Tijdstip",
    "user": "Gebruiker: id, gebruikersnaam (rol)"
  },
  "id": "Nummer activiteitenlog",
  "level": {
    "error": "Fout",
    "info": "Informatie",
    "success": "Succes",
    "warning": "Waarschuwing"
  },
  "no_events": "Geen gebeurtenissen gevonden"
}
